import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select-legacy';

const COLUMN_VISIBILITY_PLACEHOLDER = 'Column visibility';

class CheckboxOption extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocused: PropTypes.bool,
    isSelected: PropTypes.bool,
    onFocus: PropTypes.func,
    onSelect: PropTypes.func,
    option: PropTypes.object.isRequired,
  };

  handleMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onSelect(this.props.option, e);
  }

  handleMouseEnter = (e) => {
    this.props.onFocus(this.props.option, e);
  }

  handleMouseMove = (e) => {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, e);
  }

  render() {
    const { children, className, isSelected, option } = this.props;
    return (
      <div className={className} onMouseDown={this.handleMouseDown} onMouseEnter={this.handleMouseEnter} onMouseMove={this.handleMouseMove} title={option.title}>
        { isSelected && <i className='sp-icon-checkmark'></i> }
        <span className={isSelected ? 'u-margin-left--tiny' : 'u-margin-left--base' }>{ children }</span>
      </div>
    );
  }
}

const valueRender = () => ''

const SelectCheckbox = ({ value, options, onChange, disabled }) => {
  return (
    <Select
      autosize={true}
      closeOnSelect={false}
      multi={true}
      removeSelected={false}
      className='o-select o-select--checkbox'
      clearable={false}
      placeholder={COLUMN_VISIBILITY_PLACEHOLDER}
      searchable={false}
      value={value}
      onChange={onChange}
      options={options}
      optionClassName='o-select__option--checkbox'
      optionComponent={CheckboxOption}
      simpleValue={true}
      valueRenderer={valueRender}
      disabled={disabled}
    />
  );
}

SelectCheckbox.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default SelectCheckbox;
